<script lang="ts">
    import DynamicEsi from '@shared/components/dynamic-esi/DynamicEsi.svelte';
    import type { SearchContext } from '@shared/types/types.ts';
    import { sdaHoardingAttributes } from '@tilelist/domain/external-data-attributes/ExternalDataAttributes.ts';

    export type SdaHoardingSlot = 'top-slot' | 'list-slot' | 'bottom-slot';

    function normalizeTopNImplicit(topNImplicit?: { [key: string]: string[] }): { [key: string]: string[] } {
        if (!topNImplicit) return {};
        return Object.fromEntries(Object.entries(topNImplicit).map(([key, value]) => [key.toLowerCase(), value]));
    }

    function buildEsiUrl(slotName: string, searchContext?: SearchContext, ssr?: true): string {
        const normalized = normalizeTopNImplicit(searchContext?.topNImplicit);
        const params = new URLSearchParams();
        if (ssr) params.append('ssr', 'true');
        const assortmentPath = searchContext?.assortment ?? searchContext?.categoryPath;
        if (assortmentPath) params.append('assortmentPath', assortmentPath);
        const brandName = normalized['brandname']?.[0];
        if (brandName) params.append('brandName', brandName);
        const brandGroupName = normalized['brandgroupname']?.[0];
        if (brandGroupName) params.append('brandGroupName', brandGroupName);
        const produktbasisklasse = normalized['produktbasisklasse']?.[0];
        if (produktbasisklasse) params.append('produktbasisklasse', produktbasisklasse);
        const query = params.toString();
        return `/sda-hoarding/sda-new/${slotName}${query ? `?${query}` : ''}`;
    }

    function resolveEsiSrcs(slot: SdaHoardingSlot, searchContext?: SearchContext, isApp = false): string[] {
        const prefix = isApp ? 'app' : 'web';
        switch (slot) {
            case 'top-slot':
                return [buildEsiUrl('web_es_atf_native-billboard', searchContext, true)];
            case 'list-slot':
                return [buildEsiUrl('web_es_btf_native-billboard', searchContext)];
            case 'bottom-slot':
                return [
                    buildEsiUrl(`${prefix}_btf_mca_640`, searchContext),
                    buildEsiUrl(`${prefix}_btf_mca_320`, searchContext),
                ];
        }
    }

    interface Props {
        listSlot: SdaHoardingSlot;
        searchContext?: SearchContext;
        isApp?: boolean;
        featureIndex?: number;
        /*                                                                         */
        hidden?: true;
    }

    let { listSlot, searchContext, isApp = false, featureIndex, hidden }: Props = $props();

    const esiSrcs = $derived(resolveEsiSrcs(listSlot, searchContext, isApp));
</script>

<div
    class="reptile-sda-hoarding reptile-sda-hoarding--{listSlot}"
    style={hidden ? 'display: none' : undefined}
    {...sdaHoardingAttributes(featureIndex)}
>
    {#each esiSrcs as src}
        <DynamicEsi {src} name="SdaHoarding" />
    {/each}
</div>

<style lang="scss">
    @use '@otto-ec/otto-components-utils/scss/mixins';

    .reptile-sda-hoarding {
        grid-column: 1 / -1;

        &--top-slot {
            width: 100%;

            @include mixins.breakpoint-from-l() {
                width: auto;
            }
        }

        &--bottom-slot {
            width: 100%;
        }
    }
</style>
